<div *ngIf="result && loaded">
  <div *ngIf="result.errors && result.errors.length > 0" class="row mt-4">
    <div class="col-9">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" translate>ERRORS</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let error of result.errors">
            <td>
              {{ 'HL_DISPLAY_IMPORT_LINESHEET_MULTIPLE_ORDER_ERROR' | translate: { rowNumber: error.rowNumber } }}
              {{ error.error }}
            </td>
            <!--<td>{{error.sheet}} - {{error.rowNumber}}: {{error.error}} (<span translate>PRODUCT_ID</span> {{error.productId}})</td>-->
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row">
    <div class="col-9">
      @for (order of result.orders; track order; let index = $index) {
        <table class="table table-striped">
          <thead class="table-dark">
            <tr>
              <th scope="col" colspan="2">
                <span translate>ORDER</span>: {{ order.extra._customerOrderNumber }}. <span translate>CUSTOMER</span>
                {{ order.deliveryCustomerId }}
              </th>
              <th class="text-right" colspan="2">
                <span *ngIf="createdOrders[index]" class="success-text">
                  <span class="fa fa-check mr-1"></span>
                  <span translate>CREATED_ORDER</span>: {{ createdOrders[index] }}
                </span>
                <span *ngIf="errorsInCreation[index]" [ngbTooltip]="errorsInCreation[index]" class="error-text">
                  <i class="fa-regular fa-circle-exclamation mr-1"></i>
                  <span> {{ 'ERROR_WHILE_CREATING_ORDER' | translate }} - {{ errorsInCreation[index] }}</span>
                </span>
                <button
                  *ngIf="!createdOrders[index] && !errorsInCreation[index]"
                  (click)="createOrder(order, index)"
                  [disabled]="creatingOrders[index]"
                  class="btn btn-primary"
                >
                  <span *ngIf="!creatingOrders[index]" translate>CREATE_ORDER</span>
                  <span *ngIf="creatingOrders[index]">
                    <i class="fa fa-spinner fa-spin mr-1"></i>
                    <span translate>CREATING_ORDER</span>
                    <span *ngIf="orderContextStatuses[index]">
                      ({{'STEP' | translate }}: {{ orderContextStatuses[index].completedSteps }}/{{ orderContextStatuses[index].totalSteps }})
                    </span>
                  </span>
                </button>
              </th>
            </tr>
            <tr>
              <th scope="col" colspan="4" class="bg-body-secondary text-black">
                <div class="row">
                  <div class="col-6">
                    <lib-gung-text-input
                      *ngIf="!!order.extra?.oh?.godsmarke1"
                      gungTranslate="GOODS_LABEL_ROW_1"
                      [(ngModel)]="order.extra.oh.godsmarke1"
                      renderStatic="true"
                      class=""
                    />
                    <lib-gung-text-input
                      *ngIf="!!order.extra?.oh?.godsmarke2"
                      gungTranslate="GOODS_LABEL_ROW_2"
                      [(ngModel)]="order.extra.oh.godsmarke2"
                      renderStatic="true"
                      class=""
                    />
                    <lib-gung-text-input
                      *ngIf="!!order.extra?.oh?.kundref2"
                      gungTranslate="CUSTOMER_REF"
                      [(ngModel)]="order.extra.oh.kundref2"
                      renderStatic="true"
                      class=""
                    />
                    <lib-gung-text-input
                      *ngIf="!!order.extra?.oh?.q_email"
                      gungTranslate="EMAIL"
                      [(ngModel)]="order.extra.oh.q_email"
                      renderStatic="true"
                      class=""
                    />
                    <lib-gung-meta-output
                      *ngIf="!!order.extra?.oh?.ordtyp"
                      [value]="order.extra.oh.ordtyp"
                      [gungTranslate]="'ORDER_TYPE'"
                      metadataTable="x6"
                      metaOptionName="ordtypbeskr"
                      renderStatic="true"
                    />
                    <lib-gung-meta-output
                      *ngIf="!!order.extra?.oh?.salestype"
                      [value]="order.extra.oh.salestype"
                      [gungTranslate]="'SALES_TYPE'"
                      metadataTable="xsal"
                      metaOptionName="salestypedescr"
                      renderStatic="true"
                    />
                  </div>
                  <div class="col-6">
                    <lib-gung-text-input
                      *ngIf="!!order.extra?.oh?.ordlevadr1"
                      gungTranslate="OH_ORDLEVADR1"
                      [(ngModel)]="order.extra.oh.ordlevadr1"
                      renderStatic="true"
                      class=""
                    />
                    <lib-gung-text-input
                      *ngIf="!!order.extra?.oh?.ordlevadr2"
                      gungTranslate="OH_ORDLEVADR2"
                      [(ngModel)]="order.extra.oh.ordlevadr2"
                      renderStatic="true"
                      class=""
                    />
                    <lib-gung-text-input
                      *ngIf="!!order.extra?.oh?.ordlevadr3"
                      gungTranslate="OH_ORDLEVADR3"
                      [(ngModel)]="order.extra.oh.ordlevadr3"
                      renderStatic="true"
                      class=""
                    />
                    <lib-gung-text-input
                      *ngIf="!!order.extra?.oh?.ftgpostnr"
                      gungTranslate="OH_FTGPOSTNR"
                      [(ngModel)]="order.extra.oh.ftgpostnr"
                      renderStatic="true"
                      class=""
                    />
                    <lib-gung-text-input
                      *ngIf="!!order.extra?.oh?.ordlevadr4"
                      gungTranslate="OH_ORDLEVADR4"
                      [(ngModel)]="order.extra.oh.ordlevadr4"
                      renderStatic="true"
                      class=""
                    />
                    <lib-gung-text-input
                      *ngIf="!!order.extra?.oh?.ordlevadrlandskod"
                      gungTranslate="OH_ORDLEVADRLANDSKOD"
                      [(ngModel)]="order.extra.oh.ordlevadrlandskod"
                      renderStatic="true"
                      class=""
                    />
                  </div>
                </div>
              </th>
            </tr>
            <tr>
              <th translate>PRODUCT_ID</th>
              <th class="text-right" translate>QUANTITY</th>
              <th class="text-right" translate>PRICE</th>
              <th class="text-right" translate>DISCOUNT</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of order.rows">
              <td>
                <a class="redtext" [routerLink]="['/product/', row.productId]" target="_blank">{{ row.productId }}</a>
              </td>
              <td class="text-right">{{ row.quantity }}</td>
              <td class="text-right">
                {{ row.extra.orp?.vb_pris }}
              </td>
              <td class="text-right">
                {{ row.extra.orp?.rab1 }}
              </td>
            </tr>
          </tbody>
        </table>
        @if (orderContexts[index]?.eventLog?.length) {
          <div class="mt-2 mb-3">
            <h6 translate>EVENTS</h6>
            @for (event of orderContexts[index].eventLog; track event) {
              <div
                class="alert mb-1 py-1 px-2"
                [ngClass]="{
                  'alert-danger': event.level === 'ERROR',
                  'alert-warning': event.level === 'WARNING',
                  'alert-info': event.level === 'INFO',
                  'alert-secondary': event.level === 'DEBUG'
                }"
              >
                <small><strong>{{ event.step }}</strong>: {{ event.message }}</small>
              </div>
            }
          </div>
        }
      }
    </div>

    <div class="col-3">
      <div class="position-sticky" style="top: 130px">
        <div class="alert alert-warning text-left" role="alert">
          <span translate>ORDER_ID_WILL_CHANGE_ORDER_IMPORT_HELP_TEXT</span>
        </div>
        <span> <b translate> AMOUNT_OF_ORDERS </b>: {{ result.orders?.length }} </span>
        <button (click)="navigateBack()" type="button" class="btn btn-primary mt-2 d-block">
          <span> {{ 'GO_BACK' | translate }}</span>
        </button>
        <button
          [disabled]="!allowSendAll"
          type="button"
          class="btn btn-secondary mt-2 d-block"
          translate
          (click)="sendAll()"
        >
          SEND_ALL
        </button>
      </div>
    </div>
  </div>
</div>
